import { MAP_FILTER_MAX_RADIUS_KM } from '../constants/mapFilters';

const clampRadius = (radius) => {
  if (typeof radius !== 'number' || Number.isNaN(radius)) {
    return 1;
  }
  return Math.min(Math.max(radius, 1), MAP_FILTER_MAX_RADIUS_KM);
};

/**
 * Derive location-based query params from current filters and user location.
 *
 * @param {Object} filters - Filter state from useListPageFilters
 * @param {{ lat: number, lng: number } | null} userLocation - Geolocation from useListMapView
 * @returns {{ lat: number, lng: number, radius: number, source: 'map' | 'nearby' } | null}
 */
export const getLocationFilterParams = (filters = {}, userLocation = null) => {
  const hasViewportFilter =
    filters.mapViewportCenter &&
    typeof filters.mapViewportCenter.lat === 'number' &&
    typeof filters.mapViewportCenter.lng === 'number' &&
    filters.mapUserInteracted &&
    filters.mapSyncEnabled;

  if (hasViewportFilter) {
    return {
      lat: filters.mapViewportCenter.lat,
      lng: filters.mapViewportCenter.lng,
      radius: clampRadius(filters.mapViewportRadius),
      source: 'map',
    };
  }

  const hasNearbyTag =
    Array.isArray(filters.selectedTags) &&
    filters.selectedTags.includes('nearby') &&
    userLocation &&
    typeof userLocation.lat === 'number' &&
    typeof userLocation.lng === 'number';

  if (hasNearbyTag) {
    return {
      lat: userLocation.lat,
      lng: userLocation.lng,
      radius: 100,
      source: 'nearby',
    };
  }

  return null;
};


